import { Component, OnInit, Input } from "@angular/core";
import { ImageResService } from "../../services/image-res.service";
import { Profilo } from "src/app/interfaces/user";
import { Router } from "@angular/router";
import { UsersService } from "src/app/services/user.service";
import { displayOperation } from "src/app/utilities/utilities";

@Component({
  selector: "sanremo-header-lite",
  templateUrl: "./sanremo-header-lite.component.html",
  styleUrls: ['./sanremo-header-lite.component.css'],
})
export class SanremoHeaderLiteComponent implements OnInit {
  constructor(private imageService: ImageResService,
    private router: Router,
    private userService: UsersService) {}

  @Input() profilo : Profilo;
  @Input() isError : boolean;
  logoRai: string;
  logoSanremo: string;
  dropdownIsEnable = false;
  isCollapsed = false;
  edizione = {
    nome: ""
  };

  ngOnInit() {
    this.logoRai = this.imageService.getImage("logoRai");
    this.logoSanremo = this.imageService.getImage("logoRai");
    this.imageService.getCurrEditionLogo().subscribe(logo => {
      if(logo){
        let reader = new FileReader();
        reader.addEventListener(
          "load",
          () => {
            this.logoSanremo = reader.result.toString();
          },
          false
        );
        reader.readAsDataURL(logo);
      }
    });
    this.imageService
      .getEditionName()
      .subscribe(response => (this.edizione = response.edizione));
  }

  showDropdown(){
    return (displayOperation(['ExternalUserRegistration'], this.profilo.Funzionalita) ||
     displayOperation(['RecordCompanyUserRegistration'], this.profilo.Funzionalita) || 
     displayOperation(['RecordCompanyRegistration'], this.profilo.Funzionalita) || 
     displayOperation(['JurorRegistration'], this.profilo.Funzionalita));
  }

  detectChange(event) {
		this.isCollapsed = event;
	}
}
